import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HersBinsServices from "./sections/HersBinsServices";
import OurImpactInNumbers from "./sections/OurImpactInNumbers";
import LatestVideos from "./sections/LatestVideos";
import TheTalent from "./sections/TheTalent";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HersBinsServices />
      <OurImpactInNumbers />
      <LatestVideos />
      <TheTalent />
      <Footer />
    </div>;
}